import React from "react";
import { Card, Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useEffect, useState, useCallback } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from "react-hook-form"
import './style.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchDataServiceMeterCategory, setDisconnectionRequest, getDisconnectionRequest ,setCustomer } from './stateManagement/dispatch';


export default function DisconnectionManagement({ userData }) {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm()
  const [disconnection, setDisconnection] = useState()
  const dispatch = useDispatch();
  const { loading, data, apierror, disconnectionRulesDetails } = useSelector((state) => state.connectionReducer);
  useEffect(() => {
    dispatch(fetchDataServiceMeterCategory(userData));
  }, [dispatch]);

  const onSubmit = async (data) => {
    console.log(data)
    console.log(disconnection)
    const newObj = {
      CreditLimit: data.CreditLimit ? "1" : "0",
      EmergencyCreditLimit: disconnection.EmergencyCreditLimit ? "1" : "0",
      Holiday: disconnection.Holiday ? "1" : "0",
      NoDisconnectionFlag: disconnection.NoDisconnectionFlag ? "1" : "0",
      Saturday: disconnection.Saturday ? "1" : "0",
      Sunday: disconnection.Sunday ? "1" : "0",
      State: userData?.pDATASET[0]?.STATE_NAME,
      Distict:userData?.pDATASET[0]?.CIRCLE_NAME,
      ServiceCategory: data.ServiceCategory,
      MeterCategory: data.MeterCategory,
      timerange1_todate: disconnection.timerange1_todate, 
      timerange1_fromdate: disconnection.timerange1_fromdate,
      timerange2_todate: disconnection.timerange2_todate,
      timerange2_fromdate: disconnection.timerange2_fromdate,
      timerange3_todate: disconnection.timerange3_todate,
      timerange3_fromdate: disconnection.timerange3_fromdate,
      meterBalance: disconnection.meterBalance ? 1 : 0,
      meterBalanceValue: disconnection.meterBalanceValue,
      avgHourlyCharge:disconnection.avgHourlyCharge ? 1 : 0,
      avgHourlyChargeValue:disconnection.avgHourlyChargeValue,
      avgDailyCharge: disconnection.avgDailyCharge ? 1 : 0,
      avgDailyChargeValue:disconnection.avgDailyChargeValue,
      avgMonthlyCharge:disconnection.avgMonthlyCharge ? 1 : 0,
      avgMonthlyChargeValue: disconnection.avgMonthlyChargeValue
    }
   
    dispatch(setDisconnectionRequest(userData, newObj))
      .then(() => {
        // Success callback
        window.alert("Disconnection request submitted successfully!");
        reset()
      })
      .catch((error) => {
        // Handle error if needed
        console.error("An error occurred:", error);
      });
  }

  const [errorsMasterValue, setErrorsMasterValue] = useState({});
  const [percentage, setPercentage] = useState('');
  const [value, setValue] = useState('');
  const [error, setError] = useState('');
  // State variables for checkboxes
  const [checkboxStates, setCheckboxStates] = useState({
    meterBalance: false,
    avgHourlyCharge: false,
    avgDailyCharge: false,
    avgMonthlyCharge: false
  });

  const handleNumberInput = (event) => {
    const inputValue = event.target.value;
    const name = event.target.name
    // Allow only numbers
  
    setDisconnection({
      ...disconnection,
      [name]: inputValue
    })
    console.log(disconnection)
  };
  // Handle checkbox changes
  const handleCheckboxChange = (type) => (event) => {
    const { name, checked } = event.target;
   console.log(checked)
    setCheckboxStates((prevStates) => ({
      ...prevStates,
      [type.toLocaleUpperCase()]: checked,
    }));
    
    setDisconnection((prevStates) => ({
      ...prevStates,
      [name]: checked,
      [type.toLocaleUpperCase()]: checked,
    }));
    console.log(disconnection)
  };
  const handleCheckbox = (event) => {
    const { name,checked, dataset } = event.target;
    const dataName = dataset.name; // Access custom attribute using `dataset`    
    setDisconnection((prevStates) => ({
      ...prevStates,
      [dataName]: checked,
      [name]:checked
    }));
    console.log(disconnection)
  };


  const handleTime = (e)=>{
    let name = e.target.name
    setDisconnection({
      ...disconnection,
      [name]: e.target.value
    })
  }
    // Watch the values of both selects
const ServiceCategory = watch("ServiceCategory");
const MeterCategory = watch("MeterCategory");
  const handleSelectChange = async (ServiceCategory, MeterCategory) => {
    try {
      // Wait for the dispatch to complete
      await dispatch(getDisconnectionRequest(userData, ServiceCategory, MeterCategory));
      console.log(disconnectionRulesDetails)
     
    } catch (error) {
      // Handle error if needed
      console.error("An error occurred:", error);
    }
  };
  useEffect(() => {
    if (disconnectionRulesDetails?.pDATASET?.[0]) {
      // setDisconnection(disconnectionRulesDetails.pDATASET[0]);
      setDisconnection({
        "CreditLimit":disconnectionRulesDetails.pDATASET[0].PARAM_CREDITLIMIT_FLAG ? true: false,
        "EmergencyCreditLimit":disconnectionRulesDetails.pDATASET[0].PARAM_E_CREDITLIMIT_FLAG ? true: false,
        "NoDisconnectionFlag":disconnectionRulesDetails.pDATASET[0].PARAM_NO_DISCON_FLAG ? true: false,
        "Saturday":disconnectionRulesDetails.pDATASET[0].PARAM_SATURDAY_FLAG ? true: false,
        "Sunday":disconnectionRulesDetails.pDATASET[0].PARAM_SUNDAY_FLAG ? true: false,
        "Holiday":disconnectionRulesDetails.pDATASET[0].PARAM_HOLIDAY_FLAG ? true: false,
        "timerange1_fromdate":disconnectionRulesDetails.pDATASET[0].TIME_NO_DISCON_FRM_1,
        "timerange1_todate":disconnectionRulesDetails.pDATASET[0].TIME_NO_DISCON_TO_1,
        "timerange2_fromdate":disconnectionRulesDetails.pDATASET[0].TIME_NO_DISCON_FRM_2,
        "timerange2_todate":disconnectionRulesDetails.pDATASET[0].TIME_NO_DISCON_TO_2 ,
        "timerange3_fromdate":disconnectionRulesDetails.pDATASET[0].TIME_NO_DISCON_FRM_3,
        "timerange3_todate":disconnectionRulesDetails.pDATASET[0].TIME_NO_DISCON_TO_3,
        "meterBalance":disconnectionRulesDetails.pDATASET[0].METERBALNACEENABLED ? true : false,
        "meterBalanceValue":disconnectionRulesDetails.pDATASET[0].METERBALNACEVALUE,
        "avgHourlyCharge":disconnectionRulesDetails.pDATASET[0].AVGHRCHGENABLED ? true : false,
        "avgHourlyChargeValue":disconnectionRulesDetails.pDATASET[0].AVGHRCHGVALUE,
        "avgDailyCharge":disconnectionRulesDetails.pDATASET[0].AVGDAYCHGENABLED ? true: false,
        "avgDailyChargeValue":disconnectionRulesDetails.pDATASET[0].AVGDAYCHGVALUE,
        "avgMonthlyCharge":disconnectionRulesDetails.pDATASET[0].AVGMONCHGENABLED ? true : false,
        "avgMonthlyChargeValue":disconnectionRulesDetails.pDATASET[0].AVGMONCHGVALUE ,
      })
      console.log(disconnection,"part")
    }else{
      setDisconnection(disconnectionRulesDetails?.pDATASET?.[0]);
    }
  }, [disconnectionRulesDetails]);

// Call `handleSelectChange` whenever `ServiceCategory` or `MeterCategory` changes
useEffect(() => {
  if (ServiceCategory?.length != 0 && MeterCategory?.length != 0) {  // Ensure these are not undefined or null
    handleSelectChange(ServiceCategory,MeterCategory);
  }

}, [ServiceCategory, MeterCategory]);  // Include userData as a dependency

  return (
    <>
      <Card
        style={{
          height: "auto",
          width: "100%",
          backgroundColor: "#17234D",
          borderRadius: "0px",
        }}
      >
        <Card.Body>
          <Card.Title
            style={{
              color: "#fff",
              fontFamily: "Roboto-Regular",
              fontSize: "25px",
            }}
          >
            Disconnection Rules Configuration
          </Card.Title>
        </Card.Body>
      </Card>
      <div className="TriffContainer">
        <Card
          style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", margin: "30px" }}
        >
          <Card className="custom_card" >
            <>
              {" "}
              <div className="custom_container">
                <Form onSubmit={handleSubmit(onSubmit)}>

                  <Card style={{ borderWidth: 0, height: '60px', width: '100%', backgroundColor: '#FFF6D6', borderRadius: '0px' }}>
                    <Container style={{ paddingTop: '10px', }}>
                      <Row>
                        <Col sm={2} style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>State</Col>
                        <Col sm={2} style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>Distict</Col>
                      </Row>
                      <Row>
                        <Col sm={2} style={{ fontFamily: "Roboto-Regular ", fontSize: '15px' }}>{userData?.pDATASET[0]?.STATE_NAME}</Col>
                        <Col sm={2} style={{ fontFamily: "Roboto-Regular", fontSize: '15px' }}>{userData?.pDATASET[0]?.CIRCLE_NAME}</Col>
                      </Row>
                    </Container>
                  </Card>
                  <div className="ConnectioncustomContainer">
                    <Row className="mb-3">
                      <Col sm={4}>
                        <Form.Group>
                          <Form.Label><span className="req">*</span>Service Category</Form.Label>
                          <Form.Select name="ServiceCategory"  {...register("ServiceCategory",{ required: true })}  aria-label="Default select example">
                            <option value="">Select Service Category</option>
                            {data?.pDATASET?.filter(item => item.TYPE === "SERVICECATEGORY").map(service => (
                              <option key={service.ID} value={service.ID}>
                                {service.NAME}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.ServiceCategory && <span className="error">This field is required</span>}
                        </Form.Group>
                      </Col>
                      <Col sm={4}>
                        <Form.Group>
                          <Form.Label><span className="req">*</span>Meter Category</Form.Label>
                          <Form.Select name="MeterCategory" {...register("MeterCategory",{ required: true })}   aria-label="Default select example">
                            <option value="">Select Meter Category</option>

                            {data?.pDATASET?.filter(item => item.TYPE === "METERCATEGORY").map(service => (
                              <option key={service.ID} value={service.ID}>
                                {service.NAME}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.MeterCategory && <span className="error">This field is required</span>}
                        </Form.Group>
                      </Col>
                    </Row>


                    <Row className="mb-3">
                      <h6>Parameters Consideration</h6>
                      <Col sm={4}>
                      <Form.Check
                            {...register("CreditLimit")}
                            inline
                            label="Credit Limit"
                            name="CreditLimit"
                            defaultChecked
                            data-name="PARAM_CREDITLIMIT_FLAG" // Use "data-name" to follow the HTML data attribute convention
                            checked={disconnection?.CreditLimit}
                            onChange={handleCheckbox}
                          />
                        <Form.Check
                          inline
                          {...register("NoDisconnectionFlag")}
                          label="No Disconnection Flag"
                          name="NoDisconnectionFlag"
                          data-name="PARAM_NO_DISCON_FLAG"
                          checked={disconnection?.NoDisconnectionFlag}
                          onChange={handleCheckbox}
                        />
                      </Col>
                      <Col sm={4}>
                        <Form.Check
                          inline
                          {...register("EmergencyCreditLimit")}
                          label="Emergency Credit Limit"
                          name="EmergencyCreditLimit"
                          data-name="PARAM_E_CREDITLIMIT_FLAG"
                          onChange={handleCheckbox}
                          checked={disconnection?.EmergencyCreditLimit}
                          
                        />
                        <Form.Check {...register("Saturday")}
                        data-name="PARAM_SATURDAY_FLAG"
                        onChange={handleCheckbox}
                        checked={disconnection?.Saturday}
                         inline label="Saturday" name="Saturday" />
                      </Col>
                      <Col sm={4}>
                        <Form.Check inline {...register("Sunday")} label="Sunday" 
                              data-name="PARAM_SUNDAY_FLAG"
                              onChange={handleCheckbox}
                            
                       checked={disconnection?.Sunday}
                        name="Sunday" />
                        <Form.Check inline  {...register("Holiday")}
                           data-name="PARAM_HOLIDAY_FLAG"
                           onChange={handleCheckbox} 
                        checked={disconnection?.Holiday}
                        label="Holiday" name="Holiday" />
                      </Col>
                    </Row>



                    <Row className="mb-3">
                      <h6>Time Consideration</h6>
                      <Col sm={4}>
                        <Form.Group className="mb-3">
                          <label>Select a time Slot 1:</label>
                          <Row className="timeSlot" >
                            <div>
                              <Form.Control {...register("timerange1_fromdate")} type="time" 
                              onChange={handleTime}
                              name="timerange1_fromdate"
                              defaultValue={disconnection?.timerange1_fromdate} 
                              />
                            </div>
                            <div>
                              <Form.Control {...register("timerange1_todate")} type="time"
                                onChange={handleTime}
                              name="timerange1_todate"
                              defaultValue={disconnection?.timerange1_todate} 
                               />
                            </div>
                          </Row>
                        </Form.Group>
                      </Col>
                      <Col sm={4}>
                        <Form.Group className="mb-3">
                          <label>Select a time Slot 2:</label>
                          <Row className="timeSlot">
                            <div>
                              <Form.Control {...register("timerange2_fromdate")} type="time" 
                                onChange={handleTime}
                              name="timerange2_fromdate"
                              defaultValue={disconnection?.timerange2_fromdate} 
                              />
                            </div>
                            <div>
                              <Form.Control {...register("timerange2_todate")} type="time"
                                  onChange={handleTime}
                              name="timerange2_todate"
                                 defaultValue={disconnection?.timerange2_todate} 
                              />
                            </div>
                          </Row>
                        </Form.Group>
                      </Col>
                      <Col sm={4}>
                        <Form.Group className="mb-3">
                          <label>Select a time Slot 3:</label>
                          <Row className="timeSlot">
                            <div>
                              <Form.Control {...register("timerange3_fromdate")} type="time" 
                                   onChange={handleTime}
                              name="timerange3_fromdate"
                                  defaultValue={disconnection?.timerange3_fromdate} 
                                  />
                            </div>
                            <div>
                              <Form.Control {...register("timerange3_todate")} type="time" 
                                   onChange={handleTime}
                              name="timerange3_todate"
                                defaultValue={disconnection?.timerange3_todate} 
                              />
                            </div>
                          </Row>
                        </Form.Group>
                      </Col>
                    </Row>


                    <Row className="mb-3">
                      <h6>Balance Consideration</h6>
                      <Col sm={3}>
                        <Form.Group className="mb-3">
                          <Form.Check
                            inline
                            label="Meter Balance"
                            name="meterBalance" // Use the same name as the key in state
                            checked={disconnection?.meterBalance}
                            // defaultChecked={true}
                            {...register("meterBalance")}
                            onChange={handleCheckboxChange("meterBalance")}
                          />
                          <Form.Control
                            type="text"
                            {...register("meterBalanceValue")}
                            disabled={!disconnection?.meterBalance}
                            name="meterBalanceValue"
                            placeholder="₹"
                            value={disconnection?.meterBalanceValue || ''}
                            onChange={handleNumberInput}

                          />

                        </Form.Group>
                      </Col>
                      <Col sm={3}>
                        <Form.Group className="mb-3">
                          <Form.Check
                            inline
                            label="Avg Hourly Charge"
                            name="avgHourlyCharge" // Use the same name as the key in state
                            checked={disconnection?.avgHourlyCharge}
                            {...register("avgHourlyCharge")}
                            onChange={handleCheckboxChange("avgHourlyCharge")}
                          />
                          <Form.Control
                            type="text"
                            {...register("avgHourlyChargeValue")}
                            name="avgHourlyChargeValue"
                            onChange={handleNumberInput}
                            disabled={!disconnection?.avgHourlyCharge}
                     
                            value={disconnection?.avgHourlyChargeValue || ''}
                            placeholder="%"
                            maxLength={2}
                          />

                        </Form.Group>

                      </Col>
                      <Col sm={3}>

                        <Form.Group className="mb-3">
                          <Form.Check
                            inline
                            label="Avg Daily Charge"
                            name="avgDailyCharge" // Use the same name as the key in state
                            checked={disconnection?.avgDailyCharge}
                            {...register("avgDailyCharge")}
                            onChange={handleCheckboxChange("avgDailyCharge")}
                          />
                          <Form.Control
                            type="text"
                            {...register("avgDailyChargeValue")}
                            name="avgDailyChargeValue"
                            onChange={handleNumberInput}
                            disabled={!disconnection?.avgDailyCharge}
                            placeholder="%"
                        
                            value={disconnection?.avgDailyChargeValue || ''}

                            maxLength={2}
                          />

                        </Form.Group>

                      </Col>
                      <Col sm={3}>

                        <Form.Group className="mb-3">
                          <Form.Check
                            inline
                            label="Avg Monthly Charge"
                            name="avgMonthlyCharge" // Use the same name as the key in state
                            checked={disconnection?.avgMonthlyCharge}
                            {...register("avgMonthlyCharge")}
                            onChange={handleCheckboxChange("avgMonthlyCharge")}

                          />
                          <Form.Control
                            type="text"
                            {...register("avgMonthlyChargeValue")}
                            name="avgMonthlyChargeValue"
                            onChange={handleNumberInput}
                            disabled={!disconnection?.avgMonthlyCharge}
                            placeholder="%"
                            
                            value={disconnection?.avgMonthlyChargeValue || ''}
                            maxLength={2}
                          />

                        </Form.Group>

                      </Col>
                      {error && <span style={{ color: 'red' }}>{error}</span>}
                    </Row>

                    <div className="btn_div" >

                      <button className="btn btn-primary"
                        type="button"
                        onClick={() => {
                          reset(setCheckboxStates({
                            meterBalance: false,
                            avgHourlyCharge: false,
                            avgDailyCharge: false,
                            avgMonthlyCharge: false
                          })); // Clears all form fields to default (empty) values
                        }}
                      >
                        Clear All
                      </button>

                      <input className="btn btn-primary" type="submit" value="SUBMIT" />
                      {/* <Button variant="primary" onClick={handleSubmit}>Submit</Button> */}
                    </div>
                  </div>

                </Form>
              </div>
            </>
          </Card>
        </Card>
      </div>
    </>

  );
}
